import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Component to handle redirects for authenticated users visiting /login
function LoginRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Get redirect URL from query parameters or localStorage
    const urlParams = new URLSearchParams(location.search);
    const redirectFromQuery = urlParams.get('redirect');
    const redirectFromStorage = localStorage.getItem('faithinsight_login_redirect');

    const redirectUrl = redirectFromQuery || redirectFromStorage || '/dashboard';

    // Clear redirect from localStorage if it was used
    if (redirectFromStorage && redirectFromQuery) {
      localStorage.removeItem('faithinsight_login_redirect');
    }

    // Navigate to the redirect URL
    if (redirectUrl === '/catalog') {
      window.location.href = '/portal/catalog?redirect=/catalog';
    } else {
      navigate(redirectUrl, { replace: true });
    }
  }, [location.search, navigate]);

  return null; // This component just redirects, doesn't render anything
}

export default LoginRedirect;
